import { render, staticRenderFns } from "./PurchaseOrderStocksModal.vue?vue&type=template&id=b5cedb5e&scoped=true"
import script from "./PurchaseOrderStocksModal.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderStocksModal.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderStocksModal.vue?vue&type=style&index=0&id=b5cedb5e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cedb5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5cedb5e')) {
      api.createRecord('b5cedb5e', component.options)
    } else {
      api.reload('b5cedb5e', component.options)
    }
    module.hot.accept("./PurchaseOrderStocksModal.vue?vue&type=template&id=b5cedb5e&scoped=true", function () {
      api.rerender('b5cedb5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchase-orders/PurchaseOrderStocksModal.vue"
export default component.exports